export class ExpiredDocumentError extends Error {
    constructor(message: string = "Erro! Não é possível submeter documentos expirados") {
        super(message)
        this.name = "ExpiredDocumentError"
    }
}
